<div class="links">

  <a [ngStyle]="{color: theme.link.color}" [href]="'footer.legalNote' | translate" target="_blank">{{'footer.legalNoteLabel' | translate}}</a>
  <a [ngStyle]="{color: theme.link.color}" [href]="'footer.dataProtection' | translate" target="_blank">{{'footer.dataProtectionLabel' | translate}}</a>
  <img src="../../../assets/imgs/shared/ic_logo_grpdue.png" />

</div>
